import React, { useState } from 'react'
import Link from 'next/link'
import { makeStyles, Box } from '@material-ui/core'
import Fab from '@material-ui/core/Fab'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import CloseIcon from '@material-ui/icons/Close'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    right: theme.spacing(3),
    bottom: theme.spacing(12),
    zIndex: theme.zIndex.modal,
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(3),
    },
  },
  toggleButton: {
    textAlign: 'end',
  },
  card: {
    color: '#000',
    maxWidth: 372,
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#009EFF',
    color: '#fff',
    fontSize: 22,
    height: 69,
    fontFamily: 'Kanit',
  },
  cardContent: {
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '15px 10px',
    '&:last-child': {
      paddingBottom: 15,
    },
  },
  lineLink: {
    color: '#009EFF',
  },
  couponCode: {
    color: '#009EFF',
    fontWeight: 'bolder',
  },
  fabButton: {
    width: 60,
    height: 60,
    '&:hover': {
      backgroundColor: '#009EFF',
    },
  },
  iconButton: {
    fontSize: '2.3rem',
  },
}))

const MascotBox = () => {
  const classes = useStyles()
  const { t } = useTranslation('common')

  const [isShowMascot, setIsShowMascot] = useState(false)

  const ToggleShow = () => {
    setIsShowMascot((prev) => !prev)
  }

  return (
    <Box className={classes.root}>
      {isShowMascot && (
        <Card className={classes.card}>
          <Box className={classes.cardHeader}>
            <Box
              style={{
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
              }}
            >
              <img
                style={{ position: 'relative', top: '-20px', left: '-15px' }}
                src="./static/img/mascot/mc.svg"
              />
              {t('mascot.header')}
            </Box>
          </Box>

          <CardActionArea>
            <Link href="https://www.youtube.com/watch?v=qVmvwcisDb4" passHref>
              <CardContent className={classes.cardContent}>
                <span style={{ padding: '0px 20px' }}>
                  <img src="./static/img/mascot/icon-youtube.svg" />
                </span>
                <span>
                  <Typography variant="body2" color="textPrimary" component="p">
                    {t('mascot.body.list-01')}
                  </Typography>
                </span>
              </CardContent>
            </Link>
          </CardActionArea>
          <CardActionArea>
            <Link href="https://line.me/R/ti/p/@shippop" passHref>
              <CardContent className={classes.cardContent}>
                <span style={{ padding: '0px 20px' }}>
                  <img src="./static/img/mascot/icon-line.svg" />
                </span>
                <span>
                  <Typography variant="body2" color="textPrimary" component="p">
                    {t('mascot.body.list-02')}
                    <a className={classes.lineLink}>@SHIPPOP</a>
                  </Typography>
                </span>
              </CardContent>
            </Link>
          </CardActionArea>

          <CardContent className={classes.cardContent}>
            <span style={{ padding: '0px 20px' }}>
              <img src="./static/img/mascot/icon-coupon.svg" />
            </span>
            <span>
              <Typography variant="body2" color="textPrimary" component="p">
                {t('mascot.body.list-03')}
                <a className={classes.couponCode}>"NEW2023"</a>
              </Typography>
            </span>
          </CardContent>
        </Card>
      )}
      <Box className={classes.toggleButton} onClick={() => ToggleShow()}>
        <Fab
          className={classes.fabButton}
          color="primary"
          variant="round"
          aria-label="add"
        >
          {isShowMascot ? (
            <CloseIcon className={classes.iconButton} />
          ) : (
            <HelpOutlineIcon className={classes.iconButton} />
          )}
        </Fab>
      </Box>
    </Box>
  )
}

export default MascotBox
